if (!customElements.get('slider-steps')) {
  customElements.define(
    'slider-steps',
    class SliderSteps extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          sliderPrev: '[data-controls-prev]',
          sliderNext: '[data-controls-next]',
          sliderSteps: '.js-slider-steps',
          slide: '.js-slide',
          video: '.js-video',
          playButton: '.js-play-button',
          progressBar: '.js-progress-bar',
          currentStep: '.js-current-step',
          nextStep: '.js-next-step',
          addToCalendarForm: '.js-form-habits',
          addToCalendarOption: '#formCalendar1',
          addToCalendarBtn: '.js-add-to-calendar',
          datePickerInput: '.js-date-picker',
          concernsInput: '.js-concerns',
          contactPreferencesInput: '.js-contact-preferences',
          contactMethodInput: '.js-contact-method',
          purchaseReasonInput: '.js-purchase-reason',
          platformInput: '.js-platform',
          ratingInput: '.js-rating',
          siteFeedbackInput: '.js-site-feedback',
          referAFriendBtn: '.js-refer-a-friend',
          socials: '.js-socials',
        };

        this.sliderNext = document.querySelectorAll(this.selectors.sliderNext);
        this.sliderPrev = document.querySelectorAll(this.selectors.sliderPrev);
        this.nextStep = document.querySelectorAll(this.selectors.nextStep);
        this.addToCalendarBtn = document.querySelector(
          this.selectors.addToCalendarBtn
        );
        this.addToCalendarOption = document.querySelector(
          this.selectors.addToCalendarOption
        );
        this.datePickerInput = this.querySelector(
          this.selectors.datePickerInput
        );
        this.concernsInput = this.querySelector(this.selectors.concernsInput);
        this.contactPreferencesInput = this.querySelector(
          this.selectors.contactPreferencesInput
        );
        this.contactMethodInput = this.querySelector(
          this.selectors.contactMethodInput
        );
        this.purchaseReasonInput = this.querySelector(
          this.selectors.purchaseReasonInput
        );
        this.platformInput = this.querySelector(this.selectors.platformInput);
        this.ratingInput = this.querySelector(this.selectors.ratingInput);
        this.siteFeedbackInput = this.querySelector(
          this.selectors.siteFeedbackInput
        );
        this.referAFriendBtn = this.querySelector(
          this.selectors.referAFriendBtn
        );
        this.socials = this.querySelector(this.selectors.socials);
        this.video = document.querySelector(this.selectors.video);

        this.currentStepTitle = this.querySelectorAll(
          this.selectors.slide
        )[0].dataset.stepTitle;

        this.datePickerInputValue = null;
        this.concernsInputValue = null;
        this.contactPreferencesInputValue = null;
        this.contactMethodInputValue = null;
        this.purchaseReasonInputValue = null;
        this.timeOfDayPreferenceValue = null;
        this.platformInputValue = null;
        this.ratingInputValue = null;
        this.siteFeedbackInputValue = null;
        this.hasPlayed = false;

        if (this.addToCalendarOption) {
          this.timeOfDayPreferenceValue =
            this.addToCalendarOption.selectedOptions[0].text;
          this.addToCalendarBtn.href = this.addToCalendarOption.value.trim();
        }

        this.datePickerInput?.addEventListener('change', (e) => {
          this.datePickerInputValue = e.target.value;
        });

        this.concernsInput?.addEventListener('change', (e) => {
          this.concernsInputValue = e.target.value.trim();
        });

        this.contactPreferencesInput?.addEventListener('change', (e) => {
          this.contactPreferencesInputValue = e.target.value.trim();
        });

        this.contactMethodInput?.addEventListener('change', (e) => {
          this.contactMethodInputValue = e.target.value.trim();
        });

        this.purchaseReasonInput?.addEventListener('change', (e) => {
          this.purchaseReasonInputValue = e.target.value.trim();
        });

        this.addToCalendarOption?.addEventListener('change', (e) => {
          this.timeOfDayPreferenceValue = e.target.selectedOptions[0].text;
          this.addToCalendarBtn.href = e.target.value.trim();
        });

        this.addToCalendarBtn?.addEventListener('click', () => {
          analytics.track(
            'Add to Calendar Button Clicked',
            Object.assign(
              {
                button_location: 'Onboarding Funnel',
                ...(gaClientIDValue && { ga_client_id: gaClientIDValue }),
                ...(gaSessionIDValue && { ga_session_id: gaSessionIDValue }),
              },
              window.sbjsData
            )
          );
        });

        this.platformInput?.addEventListener('change', (e) => {
          this.platformInputValue = e.target.value.trim();
        });

        this.ratingInput?.addEventListener('change', (e) => {
          this.ratingInputValue = 6 - e.target.value.trim();
        });

        this.siteFeedbackInput?.addEventListener('change', (e) => {
          this.siteFeedbackInputValue = e.target.value.trim();
        });

        this.referAFriendBtn?.addEventListener('click', () => {
          analytics.track(
            'Refer a Friend Button Clicked',
            Object.assign(
              {
                button_location: 'Onboarding Funnel',
                ...(gaClientIDValue && { ga_client_id: gaClientIDValue }),
                ...(gaSessionIDValue && { ga_session_id: gaSessionIDValue }),
              },
              window.sbjsData
            )
          );
        });

        this.socials?.addEventListener('click', (e) => {
          if (e.target.tagName.toLowerCase() === 'a') {
            analytics.track(
              'Join our Community Button Clicked',
              Object.assign(
                {
                  button_location: 'Onboarding Funnel',
                  social_network: e.target.dataset.socialNetwork,
                  ...(gaClientIDValue && { ga_client_id: gaClientIDValue }),
                  ...(gaSessionIDValue && { ga_session_id: gaSessionIDValue }),
                },
                window.sbjsData
              )
            );
          }
        });

        this.init();
      }

      addToCalendar() {
        const time = this.addToCalendarOption.value.split('/')[1];
        const action = this.addToCalendarOption.value.split('/')[0];

        // Create a new Date object in local time
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        const dateString = `${year}${month}${day}T${time}`;

        // Define the event details
        const event = {
          start: dateString,
          end: dateString,
          title: action,
          description: '',
          location: 'Home',
          url: 'https://happyv.com',
          recurrence: {
            frequency: 'DAILY',
            interval: 1,
            count: 365,
          },
        };

        const dtstamp = new Date().toISOString().replace(/-|:|\.\d+/g, '');

        const icsFile = `BEGIN:VCALENDAR\r\nPRODID:-//My Company//EN\r\nVERSION:2.0\r\nBEGIN:VEVENT\r\nDTSTART:${
          event.start
        }\r\nDTEND:${event.end}\r\nSUMMARY:${event.title}\r\nDESCRIPTION:${
          event.description
        }\r\nLOCATION:${event.location}\r\nURL:${event.url}\r\nRRULE:FREQ=${
          event.recurrence.frequency
        };INTERVAL=${event.recurrence.interval};COUNT=${
          event.recurrence.count
        }\r\nDTSTAMP:${dtstamp}\r\nUID:${Date.now()}\r\nEND:VEVENT\r\nEND:VCALENDAR\r\n`;

        // Download the ICS file
        const blob = new Blob([icsFile], {
          type: 'text/calendar;charset=utf-8',
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'my-event.ics');
        link.setAttribute('target', '_self'); // Change target to _self
        link.setAttribute('rel', 'noopener noreferrer');
        link.setAttribute('style', 'display: none;');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      stopVideos() {
        this.video?.pause();
        this.video?.nextElementSibling.classList.remove('is-hidden');
      }

      playVideo() {
        [...this.querySelectorAll(this.selectors.playButton)].forEach((btn) => {
          btn.addEventListener('click', () => {
            const video = btn.previousElementSibling;
            video.play();

            // Onboarding Video Played event
            if (!this.hasPlayed) {
              analytics.track(
                'Onboarding Video Played',
                Object.assign(
                  {
                    ...(gaClientIDValue && { ga_client_id: gaClientIDValue }),
                    ...(gaSessionIDValue && {
                      ga_session_id: gaSessionIDValue,
                    }),
                  },
                  window.sbjsData
                )
              );

              this.hasPlayed = true;
            }

            btn.classList.add('is-hidden');

            video.addEventListener('ended', () => {
              video.load();
              btn.classList.remove('is-hidden');
              btn.nextElementSibling?.classList.remove('is-visible');
            });

            video.addEventListener('click', () => {
              video.pause();
              btn.classList.remove('is-hidden');
            });
          });
        });
      }

      handleSegmentEvents(swiperInstance) {
        const currentSlideElement =
          swiperInstance.slides[swiperInstance.activeIndex];
        const currentStepElement =
          currentSlideElement.querySelector('.step-flow');
        const previousSlideElement =
          swiperInstance.slides[swiperInstance.previousIndex];
        const previousStepElement =
          previousSlideElement.querySelector('.step-flow');
        let data;

        const classes = previousStepElement.classList.value.split(' ');

        classes.forEach((classModifier) => {
          if (classModifier != 'step-flow') {
            switch (classModifier) {
              case 'step-flow--1':
                data = {
                  step: swiperInstance.activeIndex,
                  ...(this.currentStepTitle && {
                    step_title: this.currentStepTitle,
                  }), //string
                };

                break;

              case 'step-flow--2':
                data = {
                  step: swiperInstance.activeIndex,
                  ...(this.currentStepTitle && {
                    step_title: this.currentStepTitle,
                  }), //string
                  ...(this.datePickerInputValue && {
                    date_of_birth: this.datePickerInputValue,
                  }), //date iso-8601 format
                  ...(this.concernsInputValue && {
                    primary_concern: this.concernsInputValue,
                  }), //string,
                };

                break;

              case 'step-flow--3':
                data = {
                  step: swiperInstance.activeIndex,
                  ...(this.currentStepTitle && {
                    step_title: this.currentStepTitle,
                  }), //string
                  ...(this.purchaseReasonInputValue && {
                    purchase_reason: this.purchaseReasonInputValue,
                  }), //string,
                };

                break;

              case 'step-flow--4':
                data = {
                  step: swiperInstance.activeIndex,
                  ...(this.currentStepTitle && {
                    step_title: this.currentStepTitle,
                  }), //string
                  ...(this.timeOfDayPreferenceValue && {
                    time_of_day_preference: this.timeOfDayPreferenceValue,
                  }), //string,
                };

                break;

              case 'step-flow--7':
                data = {
                  step: swiperInstance.activeIndex,
                  ...(this.currentStepTitle && {
                    step_title: this.currentStepTitle,
                  }), //string
                  ...(this.platformInputValue && {
                    where_did_you_hear: this.platformInputValue,
                  }), //string,
                  ...(this.ratingInputValue && {
                    website_experience_stars: this.ratingInputValue,
                  }), //number,
                  ...(this.siteFeedbackInputValue && {
                    website_experience_feedback: this.siteFeedbackInputValue,
                  }), //string,
                };

                break;

              case 'step-flow--9':
                data = {
                  step: swiperInstance.activeIndex,
                  ...(this.currentStepTitle && {
                    step_title: this.currentStepTitle,
                  }), //string
                  ...(this.contactPreferencesInputValue && {
                    contact_preferences: this.contactPreferencesInputValue,
                  }), //string,
                  ...(this.contactMethodInputValue && {
                    contact_method: this.contactMethodInputValue,
                  }), //string,
                };

                break;

              default:
                data = {
                  step: swiperInstance.activeIndex,
                  ...(this.currentStepTitle && {
                    step_title: this.currentStepTitle,
                  }), //string
                };

                break;
            }

            Object.assign(
              {
                ...(gaClientIDValue && { ga_client_id: gaClientIDValue }),
                ...(gaSessionIDValue && { ga_session_id: gaSessionIDValue }),
              },
              data,
              window.sbjsData
            );

            analytics.track('Onboarding Step Completed', data);

            if (
              swiperInstance.activeIndex + 1 ==
              swiperInstance.slides.length
            ) {
              // last step is reached
              analytics.track(
                'Onboarding Completed',
                Object.assign(
                  {
                    ...(gaClientIDValue && { ga_client_id: gaClientIDValue }),
                    ...(gaSessionIDValue && {
                      ga_session_id: gaSessionIDValue,
                    }),
                  },
                  window.sbjsData
                )
              );
            }
          }
        });
      }

      init = () => {
        const progressBar = document.querySelector(this.selectors.progressBar);
        const currentStep = document.querySelector(this.selectors.currentStep);

        const stopVideos = () => {
          this.stopVideos();
        };

        this.swiper = new Swiper(this.selectors.sliderSteps, {
          allowTouchMove: false,
          spaceBetween: 16,
          slidesPerView: 'auto',
          navigation: {
            nextEl: this.querySelector(this.selectors.sliderNext),
            prevEl: this.querySelector(this.selectors.sliderPrev),
          },
        });

        this.swiper.on('progress', function (_, progress) {
          progressBar.style.width = String(100 * progress) + '%';
        });

        this.swiper.on('slideChange', (swiper) => {
          stopVideos();
          currentStep.innerText = swiper.activeIndex + 1;
          this.currentStepTitle = this.querySelectorAll(this.selectors.slide)[
            swiper.previousIndex
          ].dataset.stepTitle;

          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
          });

          this.handleSegmentEvents(this.swiper);
        });

        this.nextStep.forEach((btn) => {
          btn.addEventListener('click', () => {
            this.swiper.slideNext();
          });
        });

        this.playVideo();
      };
    }
  );
}
